import React from "react";
import { Typography, Divider } from "antd";
import { useTranslation } from "react-i18next";

const { Title, Paragraph, Text } = Typography;

/**
 * Regulamin świadczenia usług drogą elektroniczną — proste.menu
 * Wersja dla panelu administracyjnego (modal).
 */
export const RegulaminContent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Typography style={{ padding: "0 8px" }}>
            <Title level={3}>{t("legalDocuments.regulaminTitle")}</Title>
            <Paragraph type="secondary">{t("legalDocuments.regulaminSubtitle")}</Paragraph>

            <Divider />

            <Title level={5}>{t("legalDocuments.regulaminSection1Title")}</Title>
            <Paragraph>
                1. <Text strong>{t("legalDocuments.regulaminSection1Term1")}</Text>{" "}
                {t("legalDocuments.regulaminSection1Def1")}<br />
                2. <Text strong>{t("legalDocuments.regulaminSection1Term2")}</Text>{" "}
                {t("legalDocuments.regulaminSection1Def2")}<br />
                3. <Text strong>{t("legalDocuments.regulaminSection1Term3")}</Text>{" "}
                {t("legalDocuments.regulaminSection1Def3")}<br />
                4. <Text strong>{t("legalDocuments.regulaminSection1Term4")}</Text>{" "}
                {t("legalDocuments.regulaminSection1Def4")}<br />
                5. <Text strong>{t("legalDocuments.regulaminSection1Term5")}</Text>{" "}
                {t("legalDocuments.regulaminSection1Def5")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection2Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection2Item1")}<br />
                2. {t("legalDocuments.regulaminSection2Item2")}<br />
                3. {t("legalDocuments.regulaminSection2Item3")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection3Title")}</Title>
            <Paragraph>
                {t("legalDocuments.regulaminSection3Intro")}<br />
                1. {t("legalDocuments.regulaminSection3Item1")}<br />
                2. {t("legalDocuments.regulaminSection3Item2")}<br />
                3. {t("legalDocuments.regulaminSection3Item3")}<br />
                4. {t("legalDocuments.regulaminSection3Item4")}<br />
                5. {t("legalDocuments.regulaminSection3Item5")}<br />
                6. {t("legalDocuments.regulaminSection3Item6")}<br />
                7. {t("legalDocuments.regulaminSection3Item7")}<br />
                8. {t("legalDocuments.regulaminSection3Item8")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection4Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection4Item1")}<br />
                2. {t("legalDocuments.regulaminSection4Item2")}<br />
                3. {t("legalDocuments.regulaminSection4Item3")}<br />
                4. {t("legalDocuments.regulaminSection4Item4")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection5Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection5Item1")}<br />
                2. {t("legalDocuments.regulaminSection5Item2")}<br />
                3. {t("legalDocuments.regulaminSection5Item3")}<br />
                4. {t("legalDocuments.regulaminSection5Item4")}<br />
                5. {t("legalDocuments.regulaminSection5Item5")}<br />
                6. {t("legalDocuments.regulaminSection5Item6")}<br />
                7. {t("legalDocuments.regulaminSection5Item7")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection6Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection6Item1")}<br />
                2. {t("legalDocuments.regulaminSection6Item2")}<br />
                3. {t("legalDocuments.regulaminSection6Item3")}<br />
                4. {t("legalDocuments.regulaminSection6Item4")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection7Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection7Item1")}<br />
                2. {t("legalDocuments.regulaminSection7Item2")}<br />
                3. {t("legalDocuments.regulaminSection7Item3")}<br />
                4. {t("legalDocuments.regulaminSection7Item4")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection8Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection8Item1")}<br />
                2. {t("legalDocuments.regulaminSection8Item2")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection9Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection9Item1")}<br />
                2. {t("legalDocuments.regulaminSection9Item2")}<br />
                3. {t("legalDocuments.regulaminSection9Item3")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection10Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection10Item1")}<br />
                2. {t("legalDocuments.regulaminSection10Item2")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.regulaminSection11Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.regulaminSection11Item1")}<br />
                2. {t("legalDocuments.regulaminSection11Item2")}<br />
                3. {t("legalDocuments.regulaminSection11Item3")}
            </Paragraph>
        </Typography>
    );
};

/**
 * Polityka prywatności — proste.menu
 * Wersja dla panelu administracyjnego (modal).
 */
export const PolitykaPrywatnosciContent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Typography style={{ padding: "0 8px" }}>
            <Title level={3}>{t("legalDocuments.privacyTitle")}</Title>
            <Paragraph type="secondary">{t("legalDocuments.privacySubtitle")}</Paragraph>

            <Divider />

            <Title level={5}>{t("legalDocuments.privacySection1Title")}</Title>
            <Paragraph>
                {t("legalDocuments.privacySection1Text")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection2Title")}</Title>
            <Paragraph>
                {t("legalDocuments.privacySection2Intro")}<br />
                1. <Text strong>{t("legalDocuments.privacySection2Term1")}</Text>{" "}
                {t("legalDocuments.privacySection2Def1")}<br />
                2. <Text strong>{t("legalDocuments.privacySection2Term2")}</Text>{" "}
                {t("legalDocuments.privacySection2Def2")}<br />
                3. <Text strong>{t("legalDocuments.privacySection2Term3")}</Text>{" "}
                {t("legalDocuments.privacySection2Def3")}<br />
                4. <Text strong>{t("legalDocuments.privacySection2Term4")}</Text>{" "}
                {t("legalDocuments.privacySection2Def4")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection3Title")}</Title>
            <Paragraph>
                {t("legalDocuments.privacySection3Intro")}<br />
                1. {t("legalDocuments.privacySection3Item1")}<br />
                2. {t("legalDocuments.privacySection3Item2")}<br />
                3. {t("legalDocuments.privacySection3Item3")}<br />
                4. {t("legalDocuments.privacySection3Item4")}<br />
                5. {t("legalDocuments.privacySection3Item5")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection4Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.privacySection4Item1")}<br />
                2. {t("legalDocuments.privacySection4Item2")}<br />
                3. {t("legalDocuments.privacySection4Item3")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection5Title")}</Title>
            <Paragraph>
                {t("legalDocuments.privacySection5Intro")}<br />
                1. <Text strong>{t("legalDocuments.privacySection5Term1")}</Text>{" "}
                {t("legalDocuments.privacySection5Def1")}<br />
                2. <Text strong>{t("legalDocuments.privacySection5Term2")}</Text>{" "}
                {t("legalDocuments.privacySection5Def2")}<br />
                3. <Text strong>{t("legalDocuments.privacySection5Term3")}</Text>{" "}
                {t("legalDocuments.privacySection5Def3")}<br />
                4. <Text strong>{t("legalDocuments.privacySection5Term4")}</Text>{" "}
                {t("legalDocuments.privacySection5Def4")}<br />
                5. {t("legalDocuments.privacySection5Item5")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection6Title")}</Title>
            <Paragraph>
                {t("legalDocuments.privacySection6Intro")}<br />
                1. {t("legalDocuments.privacySection6Item1")}<br />
                2. {t("legalDocuments.privacySection6Item2")}<br />
                3. {t("legalDocuments.privacySection6Item3")}<br />
                4. {t("legalDocuments.privacySection6Item4")}<br />
                5. {t("legalDocuments.privacySection6Item5")}<br />
                6. {t("legalDocuments.privacySection6Item6")}<br />
                7. {t("legalDocuments.privacySection6Item7")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection7Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.privacySection7Item1")}<br />
                2. {t("legalDocuments.privacySection7Item2")}<br />
                3. {t("legalDocuments.privacySection7Item3")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection8Title")}</Title>
            <Paragraph>
                {t("legalDocuments.privacySection8Intro")}<br />
                {t("legalDocuments.privacySection8Item1")}<br />
                {t("legalDocuments.privacySection8Item2")}<br />
                {t("legalDocuments.privacySection8Item3")}<br />
                {t("legalDocuments.privacySection8Item4")}<br />
                {t("legalDocuments.privacySection8Outro")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection9Title")}</Title>
            <Paragraph>
                1. {t("legalDocuments.privacySection9Item1")}<br />
                2. {t("legalDocuments.privacySection9Item2")}<br />
                3. {t("legalDocuments.privacySection9Item3")}
            </Paragraph>

            <Title level={5}>{t("legalDocuments.privacySection10Title")}</Title>
            <Paragraph>
                {t("legalDocuments.privacySection10Text")}
            </Paragraph>
        </Typography>
    );
};
